import { httpUtil } from './httpUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'
import { account } from './account';
export const rewards = {
    getOffers,
    getOrgLocations, // used to load stores for offer detail
    getLocations, // used to load stores for BIG map 
    getOrganisationDetail, //used to get phone, address of merchant/venue when showing offer detail
    sendRefferals,
    getRewardSchemes,
    signUpRewardScheme,
    signOutRewardScheme,
    validateSignUpCloseScheme,
    getPerformanceOffer,
    getPromotions,
    getOfferDetail
}



async function sendRefferals({
    recipients,//["j_doe@crm.com","+35722265566"]
}) {
    try {

        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: '/v1/send_referrals',
            body: {
                recipients: recipients
            },
            withAccessToken: true
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                response.error.message == "COM.CRM.TOOMANYRECIPIENTSEXCEPTION"
            ) {
                return createResult(ErrorCodes.TOO_MANY_RECIPIENTS_EXCEPTION, response.error);
            } else {
                return createCommonResult(response);
            }
        }
    } catch (e) {
        console.log('Exception sendRefferals: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getOffers({
    page = 1,
    size = 10,
    industry,
    industry_sector,
    town_city,
    organisations, //csv format,
    organisation_tag,
    sort,//='UPDATED_DATE',
    order, //='DESC'
    lat, 
    lon
} = {},) {
    try {

        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: '/v1/reward_offers',
            queryParams: {
                page,
                size,
                industry,
                industry_sector,
                town_city,
                organisation_tag: organisation_tag,
                organisations: organisations,
                sort,
                order,
                lat,
                lon
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getOffers: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getOrgLocations({
    page = 1,
    size = 100,
    industries,
    nearby_latlon,
    industry_sectors,
    town_cities,
    organisations,
    sort,//='UPDATED_DATE',
    order, //='DESC'
    relationship,
    countries,
    include_custom_fields,
    custom_fields,
    organisation_tags,
    tap_code,
    include_wifi_sites,
    lat,
    lon,
    distance
} = {}, orgId) {
    try {
        //let id = httpUtil.getSession().current_organisation_id;
        if (!orgId) {
            orgId = httpUtil.getSession().current_organisation_id;
        }
        let response = await httpUtil.get({
            resourcePath: '/v1/organisations/' + orgId + '/network',
            queryParams: {
                page,
                size,
                industries,
                nearby_latlon,
                industry_sectors,
                town_cities,
                organisations,
                sort,//='UPDATED_DATE',
                order, //='DESC'
                relationship,
                countries,
                include_custom_fields,
                custom_fields,
                organisation_tags,
                tap_code,
                include_wifi_sites,
                lat,
                lon,
                distance
            }, withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getMerchants: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function getLocations({
    // page=1,
    // size=10,
    lat,
    lon,
    industries,
    industry_sectors,
    business_activities,
    town_cities,
    organisation_tags,
    within,
    custom_fields,
    include_custom_fields,
    organisation_name
} = {},) {
    try {
        let response = await httpUtil.get({
            resourcePath: '/v1/locations',
            queryParams: {
                lat,
                lon,
                industries,
                industry_sectors,
                business_activities,
                town_cities,
                organisation_tags,
                within,
                custom_fields,
                include_custom_fields,
                organisation_name
            }, withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getMerchants: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getOrganisationDetail(orgId) {
    try {
        //let id = httpUtil.getSession().current_organisation_id;
        let response = await httpUtil.get({
            resourcePath: '/v1/organisations/' + orgId,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getOrganisationDetail: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function getRewardSchemes() {
    try {
        //let id = httpUtil.getSession().current_organisation_id;
        let response = await httpUtil.get({
            resourcePath: '/v1/reward_schemes',
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getRewardSchemes: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function signUpRewardScheme({
    reward_scheme_id,
    email_address,
    sign_up_code
}, accountId) {
    try {
        if (!accountId) {
            let primeAccRes = await account.getPrimaryAccount();
            if (primeAccRes.code != ErrorCodes.OK)
                return primeAccRes;
            if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
                return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
            accountId = primeAccRes.data.content[0].id;
        }
        //console.log('API: ', contact)
        let body = {
            reward_scheme_id,
        }
        if (sign_up_code) {
            body.sign_up_code = sign_up_code
        }
        if (email_address) {
            body.email_address = email_address
        }
        let response = await httpUtil.post({
            resourcePath: '/v1/accounts/' + accountId + '/reward_schemes',
            body: { ...body, action: 'SIGNUP' },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception signUpRewardScheme: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function signOutRewardScheme({
    reward_scheme_id,
}, accountId) {
    try {
        if (!accountId) {
            let primeAccRes = await account.getPrimaryAccount();
            if (primeAccRes.code != ErrorCodes.OK)
                return primeAccRes;
            if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
                return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
            accountId = primeAccRes.data.content[0].id;
        }
        //console.log('API: ', contact)
        let body = {
            reward_scheme_id,
        }

        let response = await httpUtil.post({
            resourcePath: '/v1/accounts/' + accountId + '/reward_schemes',
            body: { ...body, action: 'SIGNOUT' },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception signOutRewardScheme: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function validateSignUpCloseScheme(code) {
    try {
        let response = await httpUtil.post({
            resourcePath: '/v1/reward_schemes',
            body: {
                sign_up_code: code
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception validateSignUpCloseScheme: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getPerformanceOffer(offerId) {
    try {

        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: '/v1/reward_offers/' + offerId + "/performance",
            queryParams: {}
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getOffers: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getPromotions() {
    try {
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: '/v1/promotions',
            queryParams: {
                size: 20,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getOffers: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getOfferDetail(offerId) {
    try {
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: '/v1/reward_offers/' + offerId,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getOfferDetail: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

